import React from 'react';
import ReactDOM from 'react-dom';
import cs from 'react-intl/locale-data/cs';
import de from 'react-intl/locale-data/de';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import fi from 'react-intl/locale-data/fi';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';
import ja from 'react-intl/locale-data/ja';
import nl from 'react-intl/locale-data/nl';
import no from 'react-intl/locale-data/no';
import pl from 'react-intl/locale-data/pl';
import sv from 'react-intl/locale-data/sv';
import pt from 'react-intl/locale-data/pt';
import zh from 'react-intl/locale-data/zh';
import ko from 'react-intl/locale-data/ko';
import { addLocaleData } from 'react-intl';
import './assets/favicon.ico';
import './index.css';
import './icons.css';
import App from './App';

addLocaleData([
  ...cs,
  ...de,
  ...en,
  ...es,
  ...fi,
  ...fr,
  ...it,
  ...ja,
  ...nl,
  ...no,
  ...pl,
  ...pt,
  ...sv,
  ...zh,
  ...ko
]);

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js